// @see https://tailwindcss.com/docs/responsive-design
export const XS_VIEWPORT = 492;
export const SM_VIEWPORT = 640;
export const MD_VIEWPORT = 768;
export const LG_VIEWPORT = 1024;
export const XL_VIEWPORT = 1280;
